var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Edit Contact")]),(_vm.contact)?_c('contact',{attrs:{"contact":_vm.contact,"submit":_vm.handleSubmit},on:{"done":_vm.handleDone}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }